module.exports = __webpack_public_path__ + "img/北京古树游览推荐-太庙.e7930098.jpg";